import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { createActivity, deleteActivity, fetchActivity, fetchActivityDetails, updateActivity, } from "../../../service/api";


export const getActivitiesPlan = createAsyncThunk(
    "activity/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchActivity(params)
            console.log("activity plan", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getActivitiesDetails = createAsyncThunk(
    "activity/byId",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchActivityDetails(params)
            console.log("activity details", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)



export const deleteActivityAction = createAsyncThunk(
    "activity/delete",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await deleteActivity(formValue)
            if (response.status === 201) {
                console.log("delete", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const addActivityPlan = createAsyncThunk(
    "activity/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createActivity(formValue)
            if (response.status === 201) {
                console.log("activity", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

export const editActivity = createAsyncThunk(
    "activity/edit",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await updateActivity(formValue)
            if (response.status === 201) {
                console.log("activity edit", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


const activitySlice = createSlice({
    name: "activities",
    initialState: {
        activityList: [],
        activityById: {},
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: "",
        roomId: "",
        dates: "",
    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
            // state.limit = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
        setRoomFilters: (state, action) => {
            state.roomId = action.payload;
        },
        setDateFilters: (state, action) => {
            state.dates = action.payload;
        }
    },

    extraReducers: (builder) => {
        builder
            //activity plan
            .addCase(getActivitiesPlan.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getActivitiesPlan.fulfilled, (state, action) => {
                state.isLoading = false;
                state.activityList = action.payload.data;
                state.totalPage = action.payload.totalPages
            })
            .addCase(getActivitiesPlan.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })



            // POST
            .addCase(addActivityPlan.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addActivityPlan.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addActivityPlan.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // by id
            .addCase(getActivitiesDetails.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getActivitiesDetails.fulfilled, (state, action) => {
                state.isLoading = false;
                state.activityById = action.payload.data;

            })
            .addCase(getActivitiesDetails.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })


            // PUT
            .addCase(editActivity.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editActivity.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editActivity.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // DELETE
            .addCase(deleteActivityAction.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(deleteActivityAction.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(deleteActivityAction.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
    }
})

export const { setDateFilters, setRoomFilters, setSearchParams, setPagination } = activitySlice.actions;

export default activitySlice.reducer;
